import { createSlice } from "@reduxjs/toolkit";


export const userSlice = createSlice({
    name: 'users',
    initialState: {
        value: [],
    },
    reducers: {
        addUser: (state, action) => {
            state.value.push( action.payload );
        },
        addMany: (state, action) => {
            state.value = [ ...state.value, ...action.payload ];
        },
        setUsers: (state, action) => {
            state.value = action.payload;
        },
        updateUser: (state, action) => {
            const index = state.value.findIndex(a => a.id === action.payload.id);
            if (index !== -1) {
                state.value[index] = action.payload;
            }
        },
        deleteUser: (state, action) => {
            const index = state.value.findIndex(a => a.id === action.payload);
            if (index !== -1) {
                state.value = [ ...state.value.slice(0, index), ...state.value.slice(index + 1) ];
            }
        },
        clearUsers: (state) => {
            state.value = [];
        }
    }
});

export const { addUser, addMany, setUsers, updateUser, deleteUser, clearUsers } = userSlice.actions;

export default userSlice.reducer;